var exports = {
  "LA": "xf0b3b88a--392d21--iframe-container",
  "pU": "xf0b3b88a--392d21--iframe",
  "VN": "xf0b3b88a--392d21--close",
  "u1": "xf0b3b88a--392d21--spinner",
};

module.exports = exports;
